<i18n>
{
  "de": {
    "includeCAPEXLabel": "CAPEX berücksichtigen?",
    "includeCAPEX": "CAPEX-Massnahmen berücksichtigt",
    "excludeCAPEX": "CAPEX-Massnahmen nicht berücksichtigt"
  }
}
</i18n>

<template>
  <FormRow :label="$t('includeCAPEXLabel')" class="c-edit-include-capex">
    <CheckInput
      v-model="model"
      :edit="isEditing"
      :active-label="$t('includeCAPEX')"
      :inactive-label="$t('excludeCAPEX')"
      @input="onInput"
      @validation="onValidation($event, 'include_capex')"
    />
  </FormRow>
</template>

<script>
import ComplexFormStateMixin from '@/components/shared/forms/ComplexFormStateMixin.vue'

import FormRow from '@/components/shared/forms/FormRow.vue'
import CheckInput from '@/components/shared/forms/CheckInput.vue'

export default {
  mixins: [
    //
    ComplexFormStateMixin,
  ],

  components: {
    FormRow,
    CheckInput,
  },

  props: {
    edit: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.c-edit-include-capex {
  max-width: 50%;
  padding-bottom: var(--spacing-m);
}
</style>
